/**
 * Подпись исходного документа «файл · лист» (фича 038).
 *
 * С фичи 016 каждый лист Excel-книги — отдельная запись `files` с общим
 * `originalName`, поэтому без листа строки разных листов одной книги в
 * проверках и сверке неразличимы. Лист показывается всегда, когда известен.
 */

/** «файл» или «файл<separator>лист»; пустой лист — только файл. */
export function formatFileSheetLabel(
	fileName: string,
	sheetName: string | null | undefined,
	separator: string,
): string {
	return sheetName ? `${fileName}${separator}${sheetName}` : fileName;
}
